module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "global-slider-container"
  }, [_c('div', {
    class: ("slider-" + (_vm.componentParams.template))
  }, [(_vm.componentParams.template == "default") ? [_c('slider-default', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "updated": _vm.renderOwl
    }
  })] : (_vm.componentParams.template == "mainSlider") ? [_c('slider-main', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "updated": _vm.renderOwl
    }
  })] : (_vm.componentParams.template == "mainSlider2") ? [_c('slider-main2', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "updated": _vm.renderOwl
    }
  })] : (_vm.componentParams.template == "catalogVueslider") ? [_c('slider-catalog', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "updated": _vm.renderOwl
    }
  })] : (_vm.componentParams.template == "lowCost") ? [_c('slider-lowcost', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "updated": _vm.renderOwl
    }
  })] : (_vm.componentParams.template == "detailPhoto") ? [_c('slider-detail', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "updated": _vm.renderOwl
    }
  })] : (_vm.componentParams.template == "photo2") ? [_c('slider-photo2', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "updated": _vm.renderOwl
    }
  })] : (_vm.componentParams.template == "otherNews") ? [_c('slider-otherNews', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "updated": _vm.renderOwl
    }
  })] : (_vm.componentParams.template == "lowCost2") ? [_c('slider-other-stock', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "updated": _vm.renderOwl
    }
  })] : (_vm.componentParams.template == "stock2") ? [_c('slider-stock2', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "updated": _vm.renderOwl
    }
  })] : (_vm.componentParams.template == "stockProduct") ? [_c('slider-stockp-product', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "updated": _vm.renderOwl
    }
  })] : (_vm.componentParams.template == "lastProject") ? [_c('slider-lastproject', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "updated": _vm.renderOwl
    }
  })] : (_vm.componentParams.template == "catalogVuesliderToSections") ? [_c('slider-catalog-to-section', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "updated": _vm.renderOwl
    }
  })] : (_vm.componentParams.template == "swimSlider") ? [_c('slider-swim', {
    attrs: {
      "items": _vm.items
    },
    on: {
      "updated": _vm.renderOwl
    }
  })] : [_vm._v("\n\t\t\tUnknown slider template: "), _c('b', [_vm._v(_vm._s(_vm.componentParams.template))])]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7438c203"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/Slider.vue
// module id = 258
// module chunks = 35